import React from "react";

export const SvgGuest = (props) => {
	return (
		<svg
			width="19"
			height="20"
			viewBox="0 0 19 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9.49707 9.58692C11.8747 9.58692 13.8096 7.65204 13.8096 5.27441C13.8096 2.89679 11.8747 0.961914 9.49707 0.961914C7.11945 0.961914 5.18457 2.89679 5.18457 5.27441C5.18457 7.65204 7.11945 9.58692 9.49707 9.58692ZM9.49707 2.87858C10.8186 2.87858 11.8929 3.95287 11.8929 5.27441C11.8929 6.59596 10.8186 7.67025 9.49707 7.67025C8.17649 7.67025 7.10124 6.59596 7.10124 5.27441C7.10124 3.95287 8.17649 2.87858 9.49707 2.87858Z"
				fill={props.color ? props.color : "#2368a2"}
			/>
			<path
				d="M18.8451 17.9119C17.8485 13.5228 14.0046 10.458 9.49849 10.458C4.99145 10.458 1.14853 13.5237 0.152826 17.9119C0.0359095 18.4285 0.358868 18.9421 0.87541 19.0591C1.39003 19.1741 1.90466 18.8521 2.02158 18.3365C2.81795 14.8271 5.89228 12.3747 9.49849 12.3747C13.1037 12.3747 16.179 14.8271 16.9754 18.3374C17.076 18.7821 17.4718 19.083 17.9088 19.083C17.9788 19.083 18.0497 19.0753 18.1225 19.06C18.6381 18.9421 18.962 18.4285 18.8451 17.9119Z"
				fill={props.color ? props.color : "#2368a2"}
			/>
		</svg>
	);
};
